<script setup lang="ts">
import {toRef, useAttrs} from "vue";
defineOptions({
    inheritAttrs: false,
});
const attrs = useAttrs();
const props = defineProps({
    type: {
        type: String,
        default: "text",
        required: false,
    },
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [String, Number, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },

    error: {
        type: String,
        default: null,
    },
    errorId: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: [String],
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
    min: {
        type: [Number, String],
        default: null,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");
</script>

<template>
    <input
        v-bind="attrs"
        :name="name"
        :id="name"
        :type="type"
        :value="props.modelValue"
        :min="min"
        :maxlength="maxLength"
        class="form-control"
        :class="{'is-invalid': !!error}"
        :disabled="disabled"
        :placeholder="placeholder"
        :readonly="readonly"
        :aria-invalid="error ? 'true' : null"
        :aria-describedby="error ? `${name}-error` : null"
        @input="emit('update:modelValue', $event.target.value)" />

    <slot name="append"></slot>

    <span
        :id="`${name}-error`"
        class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error }}
    </span>
</template>
